// İSG uzmanı portalı — İş İzni (Permits) TanStack Query anahtarları (api-contract §14/§17,
// tenant-scoped). Liste anahtarı parametreleri içerir (filtre/sayfa değişince yeniden çeker);
// invalidasyon önek (prefix) ile yapılır: `['permits','list']` tüm liste sorgularını,
// `['permits','detail',uuid]` bir iznin detayını (gerekli eğitim + personel + readiness dahil,
// hepsi tek `GET /permits/{uuid}` içinde) kapsar.
//
// Taşeron (§13) / Ziyaretçi (§11) anahtarlarından AYRIDIR — İş İzni tek firmaya kapsanmış
// tenant iş modülüdür.

import type { PermitListParams } from '@isgportal/shared';

export const permitsKeys = {
  /** Tüm izin sorgularının kök öneki — invalidasyon için. */
  all: () => ['permits'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['permits', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: PermitListParams) => ['permits', 'list', params] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['permits', 'access'] as const,
  /** Tek izin detayı (gerekli eğitim + personel + readiness dahil). */
  detail: (uuid: string) => ['permits', 'detail', uuid] as const,
  /** TÜM izin detaylarının öneki — bir belge onayı aracın/kişinin bağlı olduğu HER izni etkiler. */
  detailAll: () => ['permits', 'detail'] as const,
  /** İznin Aksiyonlar akışı (sistem-log + yorum; SPEC §5 — `GET /permits/{uuid}/activities`). */
  activities: (uuid: string) => ['permits', 'activities', uuid] as const,
  /** İzne personel ekle penceresinin aday listesi (taşeronun personeli; GL6 §4.8 yenilemesi bunu hedefler). */
  personnelOptions: (contractorUuid: string) =>
    ['permits', 'options', 'personnel', contractorUuid] as const,
} as const;
